// 案件設定: 「投稿確認のあと、2次利用の依頼DMを自動で送る」トグル＋テンプレ選択（第3弾）。
// 報酬・料率タブの案件フォームと新規案件モーダルで共用する。2次利用なしの案件では出さない。
import { useEffect, useState } from "react";
import { fetchGfTemplates } from "../../../api/giftingClient";
import { DEFAULT_REUSE_DM_TEMPLATE_ID } from "../../../lib/giftingRules";
import type { GfTemplate } from "../../../types/gifting";

export function ReuseDmSetting({
  auto,
  templateId,
  onAuto,
  onTemplate,
}: {
  auto: boolean;
  /** null=既定「ご投稿のお礼」 */
  templateId: string | null;
  onAuto: (v: boolean) => void;
  onTemplate: (id: string | null) => void;
}) {
  const [templates, setTemplates] = useState<GfTemplate[] | null>(null);
  useEffect(() => {
    let live = true;
    fetchGfTemplates()
      .then((d) => live && setTemplates(d))
      .catch(() => live && setTemplates([]));
    return () => {
      live = false;
    };
  }, []);

  const current = templateId === DEFAULT_REUSE_DM_TEMPLATE_ID ? null : templateId;
  const others = (templates ?? []).filter((t) => t.id !== DEFAULT_REUSE_DM_TEMPLATE_ID);
  // 一覧に無い（削除済みなど）IDを選択中のときも、その値を選択肢に残す
  const missing = current !== null && !others.some((t) => t.id === current);

  return (
    <div className="gf-setting">
      <label className="gf-check">
        <input type="checkbox" checked={auto} onChange={(e) => onAuto(e.target.checked)} />
        <span>投稿確認のあと、2次利用の依頼DMを自動で送る</span>
      </label>
      {auto && (
        <>
          <select
            className="gf-select"
            aria-label="2次利用の依頼DMのテンプレート"
            value={current ?? ""}
            onChange={(e) => onTemplate(e.target.value === "" ? null : e.target.value)}
          >
            <option value="">ご投稿のお礼（既定）</option>
            {others.map((t) => (
              <option key={t.id} value={t.id}>
                {t.name}
              </option>
            ))}
            {missing && <option value={current as string}>{current}</option>}
          </select>
          <span className="gf-note gf-lh">
            投稿を確認して「2次利用の許諾」の段階へ進めた直後に、Instagram DM で送ります。Instagram の仕様で、相手の最後のメッセージから24時間を過ぎると自動送信できません（失敗したら履歴に残ります）。
          </span>
        </>
      )}
    </div>
  );
}
